import React from 'react';
const SvgClose = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M29.333 5.47L26.53 2.668 16 13.187 5.47 2.666 2.668 5.47 13.187 16 2.666 26.53l2.804 2.803L16 18.813l10.53 10.52 2.803-2.804L18.813 16z", fillRule: "evenodd" })));
export default SvgClose;
//# sourceMappingURL=Close.js.map